<div
   cdkDropList
   [cdkDropListData]="item"
   [id]="zoneId"
   [cdkDropListConnectedTo]="availableDropZones"
   [ngClass]="{ 'sam-opacity-medium sam-cursor-disabled': disabled }"
>
   <div
      cdkDrag
      cdkDragRootElement="tr"
      [cdkDragConstrainPosition]="0"
      [cdkDragData]="item"
      (cdkDragStarted)="dragStarted(item)"
      (cdkDragEnded)="dragEnded(item)"
   >
      <ng-content select="[itemContent]"></ng-content>
      <div *cdkDragPreview class="sam-margin sam-center sam-padding dragged-item">
         <ng-content select="[dragPreview]"></ng-content>
      </div>
   </div>
   <div [ngClass]="{ 'sam-display-none': !(isDragged$ | async) }">
      <div class="sam-margin-left sam-center">
         <ng-content select="[dragPlaceHolder]"></ng-content>
      </div>
   </div>
</div>
